import { SMApp } from "@/store";
import VueRouter from "vue-router";

export const useHistorySaver = (router: VueRouter) => {
  router.afterEach((to) => {
    SMApp.addRouteToRouterHistory(to.path);
  });
};
